import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import AppScrollArea from '../../../../../components/common/AppScrollArea';
import Loader from '../../../../../components/Loader';

/** 全屏订单待办/详情 Modal：body 区 flex 占满 header 与 footer 之间 */
const OrderFullscreenModalBody = ({ isLoading, children }) => {
	const [hasShownContent, setHasShownContent] = useState(!isLoading);

	useEffect(() => {
		if (!isLoading) setHasShownContent(true);
	}, [isLoading]);

	const showInitialPlaceholder = isLoading && !hasShownContent;

	return (
		<Modal.Body className='px-x1 pt-1 pb-0 fs-10 order-fullscreen-modal__body position-relative'>
			{showInitialPlaceholder ? (
				<div className='order-fullscreen-modal__loading'>
					<Loader />
				</div>
			) : (
				<>
					{isLoading ? (
						<div className='order-fullscreen-modal__loading order-fullscreen-modal__loading--overlay'>
							<Loader />
						</div>
					) : null}
					<AppScrollArea
						maxHeight='100%'
						fillViewport
						className='order-fullscreen-modal__scroll'
						style={{ flex: '1 1 0', minHeight: 0, height: '100%' }}
					>
						{children}
					</AppScrollArea>
				</>
			)}
		</Modal.Body>
	);
};

OrderFullscreenModalBody.propTypes = {
	isLoading: PropTypes.bool,
	children: PropTypes.node,
};

export default OrderFullscreenModalBody;
